<template>
    <div class="apsppaui06">
        
        <div class="top-prompt">
            <div>說明</div>
            <div v-for="(prompt, index) in prompts.main.datas" :key="index">
                {{index + 1}}. {{prompt.DictValue}}
            </div>
        </div>

        <sag-form>
            <aps-ppa-ui-06q
                :GridData="pageGridDatas[2]"
                :name="'QueryH'"
            ></aps-ppa-ui-06q>
            <sag-card>
                <sag-basic-table
                    title="計畫分批交期試算結果"
                    subtitle=""
                    :GridData="pageGridDatas[0]"
                    :serviceName="serviceName"
                    @previewModalOpenEvent="HGridDataEvents.previewModalOpenEvent"
                    @editModalOpenEvent="HGridDataEvents.editModalOpenEvent"
                    @deleteDataEvent="HGridDataEvents.deleteDataEvent"
                    :options="{ 
                        multiple: true,
                        selectCheckBox: false
                    }"
                >

                    <template v-slot:previewModal>
                        <aps-ppa-ui-06hp
                            :GridData="pageGridDatas[0]"
                            :name="'PreviewH'"
                        ></aps-ppa-ui-06hp>
                    </template>

                    <template v-slot:sub-grid>
                        <sag-basic-table
                            title=""
                            subtitle=""
                            :GridData="pageGridDatas[1]"
                            :serviceName="serviceName"
                            @previewModalOpenEvent="DGridDataEvents.previewModalOpenEvent"
                            @editModalOpenEvent="DGridDataEvents.editModalOpenEvent"
                            @deleteDataEvent="DGridDataEvents.deleteDataEvent"
                            :options="{
                                selectCheckBox: false
                            }"
                        >

                            <template v-slot:previewModal>
                                <aps-ppa-ui-06dp
                                    :GridData="pageGridDatas[1]"
                                    :name="'PreviewD'"
                                ></aps-ppa-ui-06dp>
                            </template>
                        
                        </sag-basic-table>
                    </template>
                </sag-basic-table>
            </sag-card>
        </sag-form>
    </div>
</template>

<script>
import SagCard from '@/components/basic/SagCard.vue'
import SagForm from '@/components/basic/SagForm.vue'
import Toast from '@/views/components/toasts/ToastsBasic.vue'
import SagBasicTable from '@/components/sag-basic-table/SagBasicTable.vue'
import ApsPpaUi06hp from './APSPPAUI06HP.vue'
import ApsPpaUi06dp from './APSPPAUI06DP.vue'
import ApsPpaUi06q from './APSPPAUI06Q.vue'
import SagOpenWindow from '@/components/sag-open-window/SagOpenWindow.vue'
import store from '@/store'
import pageJs from './js'
import tools from '@/sag-core/tools'
import { ref, reactive } from '@vue/composition-api'

import { 
    BButton,
    BRow, 
    BCol 
} from 'bootstrap-vue'

export default {
    components: {
        ApsPpaUi06hp,
        ApsPpaUi06dp,
        ApsPpaUi06q,
        BButton,
        SagForm,
        SagCard,
        SagBasicTable,
        SagOpenWindow,
        BRow,
        BCol,
        Toast
    },
    setup(){
        
        // init
        pageJs.page.pageInit()
        const serviceName = pageJs.page.pageInfo.serviceName
        
        const {
            pageGridDatas,
            pageApiDatas
        } = store.state[serviceName]
 
        const apiQueryConfig = pageApiDatas.apiQueryConfig
        
        // #region GridData api後處理設定

        pageGridDatas[0].getData = (args)=>{
            const that = pageGridDatas[0]
            that.status.setQuery()
            return new Promise((ok, no)=>{
                pageJs.api.apiHData(args).then(res=>{
                    that.fillRows(res)
                    tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: `${that.name} 資料灌入`}, that, res)
                    ok(res)
                })
            })
        }

        pageGridDatas[0].insertData = (args)=>{
            const that = pageGridDatas[0]
            that.status.setInsert()
            return new Promise((ok, no)=>{
                pageJs.api.apiHDataInsert(args).then(res=>{
                    ok(res)
                })
            })
        }

        pageGridDatas[0].deleteData = (args)=>{
            const that = pageGridDatas[0]
            that.status.setDelete()
            return new Promise((ok, no)=>{
                pageJs.api.apiHDataDelete(args).then(res=>{
                    ok(res)
                })
            })
        }

        pageGridDatas[0].updateData = (args)=>{
            const that = pageGridDatas[0]
            that.status.setUpdate()
            return new Promise((ok, no)=>{
                pageJs.api.apiHDataUpdate(args).then(res=>{
                    ok(res)
                })
            })
        }

        pageGridDatas[1].getData = (args)=>{
            const that = pageGridDatas[1]
            that.status.setQuery()
            return new Promise((ok, no)=>{
                pageJs.api.apiDData(args).then(res=>{
                    that.fillRows(res)
                    ok(res)
                })
            })
        }

        pageGridDatas[1].insertData = (args)=>{
            const that = pageGridDatas[1]
            that.status.setInsert()
            return new Promise((ok, no)=>{
                pageJs.api.apiDDataInsert(args).then(res=>{
                    ok(res)
                })
            })
        }

        pageGridDatas[1].deleteData = (args)=>{
            const that = pageGridDatas[1]
            that.status.setDelete()
            return new Promise((ok, no)=>{
                pageJs.api.apiDDataDelete(args).then(res=>{
                    ok(res)
                })
            })
        }

        pageGridDatas[1].updateData = (args)=>{
            const that = pageGridDatas[1]
            that.status.setUpdate()
            return new Promise((ok, no)=>{
                pageJs.api.apiDDataUpdate(args).then(res=>{
                    ok(res)
                })
            })
        }

        // #endregion

        // #region 刪除按鈕觸發

        store.dispatch(`${serviceName}/eventAdd`, {
            name: `${pageGridDatas[0].name}/sagBasicTable/delete`,
            event: ()=>{
                pageGridDatas[0].deleteData(pageGridDatas[0].current.data)

                pageGridDatas[0].rows.splice(pageGridDatas[0].current.index, 1)
            }
        })

        store.dispatch(`${serviceName}/eventAdd`, {
            name: `${pageGridDatas[1].name}/sagBasicTable/delete`,
            event: ()=>{
                pageGridDatas[1].deleteData(pageGridDatas[1].current.data)

                pageGridDatas[1].rows.splice(pageGridDatas[1].current.index, 1)
            }
        })

        // #endregion

        const HGridDataEvents = {
            previewModalOpenEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[0].name}/sagBasicTable/previewModalOpen`,
                    args: true
                })
            },
            editModalOpenEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[0].name}/sagBasicTable/editModalOpen`,
                    args: true
                })
            },
            deleteDataEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[0].name}/sagBasicTable/delete`,
                    args: null
                })
            }
        }

        const DGridDataEvents = {
            previewModalOpenEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[1].name}/sagBasicTable/previewModalOpen`,
                    args: true
                })
            },
            editModalOpenEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[1].name}/sagBasicTable/editModalOpen`,
                    argsdeleteDataEventdeleteDataEvent: true
                })
            },
            deleteDataEvent: ()=>{
                store.dispatch(`${serviceName}/eventInvoke`, {
                    name: `${pageGridDatas[1].name}/sagBasicTable/delete`,
                    args: null
                })
            }
        }

        const arrEx = tools.arrEx
        // #region 開窗
        pageGridDatas[2].getData = ()=>{
            const that = pageGridDatas[2]
            that.status.setQuery()
            return new Promise((ok, no)=>{
                pageJs.api.apiGetINVMB().then(res=>{
                    that.fillRows(res)
                    tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: `${that.name} 資料灌入`}, that, res)
                    ok(res)
                })
            })
        }
        pageGridDatas[2].getData()
        // const openWindowDatas = ref([])
        // pageJs.api.apiGetINVMB().then(data=>{
        //     tools.debug.log({tag: 'test', title: '品號資料api測試', content: ''}, data)
        //     arrEx.clear(openWindowDatas.value)
        //     arrEx.fill(openWindowDatas.value, data)
        // })
        
        // #endregion

        // #region 提示
        const prompts = reactive(
            {
                all: {
                    datas: []
                },
                main: {
                    key: 'MainPage',
                    datas: []
                },
                error: {
                    key: 'ErrorMessage',
                    datas: []
                },
                query: {
                    key : 'QueryPage',
                    datas: []
                }
            }
        )
        pageJs.api.apiGetPrompts().then(data=>{
            tools.debug.log({tag: 'test', title: '提示資料api測試', content: ''}, data, )
            
            let keys = Object.keys(prompts)
            for(let i = 0; i < keys.length; i++){
                let key = keys[i]

                if(key === 'all'){
                    arrEx.clear(prompts[key].datas)
                    arrEx.fill(prompts[key].datas, data)
                }
                else{
                    arrEx.clear(prompts[key].datas)
                    arrEx.fill(prompts[key].datas, data.filter(e => e.DictKey === prompts[key].key))
                }
            }

            tools.debug.log({tag: 'test', title: '提示資料api測試', content: 'prompts'}, prompts)
        })
        // #endregion

        return {
            pageGridDatas,
            apiQueryConfig,
            serviceName,
            prompts,
            HGridDataEvents,
            DGridDataEvents
        }
    }
}
</script>

<style lang="scss" scoped>
.apsppaui06 {
    .top-prompt {
        margin-bottom: 10px;
    }
}
</style>
